// src/data/diagnosisTypes.ts

import { DiagnosisType } from '../types';

const diagnosisTypes: DiagnosisType[] = [
  {
    typeName: 'スダチタイプ',
    horizontalRange: [-3, 3], // 中間
    verticalRange: [-3, 3],   // 中間
    description: 'あなたの子育てタイプはとても理想的です。この調子でお子さんと接し続けてあげてください。',
    imageUrl: ['/images/sudachi_type.png'],
    color: '#60A5FA', // 青系
    showArea: true
  },
  {
    typeName: '厳格／過保護タイプ',
    horizontalRange: [0, 0],   // 中間
    verticalRange: [0, 15],  // 支配
    description: 'お子さんをしっかり守りながらも、時に命令や強制をしてしまうことがあるかもしれません。',
    imageUrl: ['/images/overprotective_type.png','/images/overprotective_type.png'],
    color: '#3B82F6', // 青系
    showArea: false
  },
  {
    typeName: '過保護／言いなりタイプ',
    horizontalRange: [0, 15],  // 保護
    verticalRange: [0, 0],    // 中間
    description: 'お子さんをしっかり守りながらも、ついお子さんの言うことを優先しすぎてしまうことがあるかもしれません。',
    imageUrl: ['/images/overprotective_type.png','/images/indulgent_type.png'],
    color: '#F59E0B', // オレンジ系
    showArea: false
  },
  {
    typeName: '放任／言いなりタイプ',
    horizontalRange: [0, 0],   // 中間
    verticalRange: [-15, 0],    // 服従
    description: 'お子さんとの関わりが少ない中で、つい甘やかしてしまうことがあるかもしれません。',
    imageUrl: ['/images/permissive_type.png','/images/indulgent_type.png',],
    color: '#EF4444', // 赤系
    showArea: false
  },
  {
    typeName: '厳格／放任タイプ',
    horizontalRange: [-15, 0], // 拒否
    verticalRange: [0, 0],     // 中間
    description: 'お子さんに厳しく指導する一方で、関わる時間が少なくなりがちかもしれません。',
    imageUrl: ['/images/strict_type.png','/images/permissive_type.png'],
    color: '#6B7280', // グレー系
    showArea: false
  },
  {
    typeName: '過保護タイプ',
    horizontalRange: [0, 15], // 保護
    verticalRange: [0, 15],  // 支配
    description: 'あなたはお子さんのことを大切に思いすぎて、少し過干渉になる傾向があるかもしれません。',
    imageUrl: ['/images/overprotective_type.png'],
    color: '#F87171', // 赤系
    showArea: true
  },
  {
    typeName: '言いなりタイプ',
    horizontalRange: [0, 15], // 保護
    verticalRange: [-15, 0],    // 服従
    description: 'あなたはお子さんの言うことを優先しすぎて、甘やかしてしまう傾向があるかもしれません。',
    imageUrl: ['/images/indulgent_type.png'],
    color: '#FBBF24', // 黄系
    showArea: true
  },
  {
    typeName: '厳格タイプ',
    horizontalRange: [-15, 0], // 拒否
    verticalRange: [0, 15],   // 支配
    description: 'あなたはルールや規律を重んじて、お子さんに少し厳しく接する傾向があるかもしれません。',
    imageUrl: ['/images/strict_type.png'],
    color: '#10B981', // 緑系
    showArea: true
  },
  {
    typeName: '放任タイプ',
    horizontalRange: [-15, 0], // 拒否
    verticalRange: [-15, 0],     // 服従
    description: 'あなたはお子さんに自由を与えすぎて、関心を持つ機会が少ない傾向があるかもしれません。',
    imageUrl: ['/images/permissive_type.png'],
    color: '#A78BFA', // 紫系
    showArea: true
  },
];

export default diagnosisTypes;
